<h3>
  Nieuwe Leden toevoegen
</h3>
<p>
  Voeg hier een csv toe met nieuwe leden.<b>Let Op!</b> Een leden bestand svg
  moet gesepereerd zijn met een ',' comma. Hij moet bestaan uit iniedergeval de
  volgende kolommen de rest word genegeerd.

  <mat-list fxLayout="row wrap" fxLayoutAlign="start start">
    <mat-list-item fxFlex="19%">name.first</mat-list-item>
    <mat-list-item fxFlex="19%">name.infix</mat-list-item>
    <mat-list-item fxFlex="19%">name.last</mat-list-item>
    <mat-list-item fxFlex="19%">name.initials</mat-list-item>
    <mat-list-item fxFlex="19%">student_number</mat-list-item>
    <mat-list-item fxFlex="19%">sex</mat-list-item>
    <mat-list-item fxFlex="19%">date_of_birth</mat-list-item>
    <mat-list-item fxFlex="19%">phone_number</mat-list-item>
    <mat-list-item fxFlex="19%">email_address</mat-list-item>
    <mat-list-item fxFlex="19%">address</mat-list-item>
    <mat-list-item fxFlex="19%">postal_code</mat-list-item>
    <mat-list-item fxFlex="19%">city</mat-list-item>
    <mat-list-item fxFlex="19%">study</mat-list-item>
  </mat-list>
  Alles mag leeg zijn behalve het email adress. De eerste regel is de header en
  foutieve emails stopt het hele process! Je krijgt een lijst terug met mensen
  waarbij het niet is gelukt. Zit jij niet bij de WebCie? Zorg dan dat je hebt
  overlegt met de WebCie of je het goed doet!
</p>
<p>
  <b>KIJK ALTIJD HANDMATIG DE DATA DOOR!</b> Bijvoorbeeld een emailadress als
  "0&#64;0.nl" komt wel door het systeem alleen mag dit lid niet worden toegevoegd.
  Dit kan met excell.
</p>
<input
  type="file"
  class="upload"
  (change)="changeListener($event.target.files)"
  />
  <mat-form-field>
    <input
      matInput
      [matDatepicker]="memSinc"
      [(ngModel)]="memberSince"
      placeholder="Lid geworden op:"
      />
      <mat-datepicker-toggle matSuffix [for]="memSinc"></mat-datepicker-toggle>
      <mat-datepicker #memSinc></mat-datepicker>
    </mat-form-field>
    Zet je deze op Afroeilid of Actieflid: (afroeileden worden ToBeMember en
    actieflid worden Member)
    @if (uploading) {
      <mat-spinner> </mat-spinner>
    }
    @if (error) {
      <div>
        <button (click)="error = undefined" mat-raised-button>Oke pas het aan</button>
        <b>Error!</b>
        <pre>{{ error | json }}</pre>
      </div>
    }
    <mat-form-field>
      <mat-label>Nieuwe leden Status</mat-label>
      <mat-select [(ngModel)]="memberStatusID">
        @for (status of memberStatusTypes; track status) {
          <mat-option
            [value]="status.typeID"
            >
            {{ status.value }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (fileSize) {
      <span>{{ toMb(fileSize) }} kb</span>
    }

    <button (click)="saveFile()" [disabled]="uploading" mat-raised-button>
      Uploaden
    </button>
    @if (uploading) {
      <mat-spinner> </mat-spinner>
    }
    @if (error) {
      <div>
        <b>Error!</b>
        <pre>{{ error | json }}</pre>
      </div>
    }
